module.exports = __webpack_public_path__ + "static/mvpsports-1b8396a14cd57b980228db9c87ebbc18.jpg";